// extracted by mini-css-extract-plugin
module.exports = {"toggle":"switch_toggle__2cMbI","slider":"switch_slider__3VnGu","hideText":"switch_hideText__1cYri"};